<template>
    <div class="page-container">
        <div class="page-content step-1" v-show="currentStep == 1">
            <div class="page-title">
                请输入原交易密码 <span>(忘记原交易密码请联系客服)</span>
            </div>
            <div class="input-grp">
                <input type="password" maxlength="6" v-model="passwdOrigin" placeholder="请输入原交易密码">
            </div>
            <div class="page-title">
                新交易密码 <span>(设置6位数字的交易密码)</span>
            </div>
            <div class="input-grp">
                <input type="password" maxlength="6" v-model="passwd1" @input="passwd1Error = false" placeholder="请输入新交易密码">
                <div class="notice" v-show="passwd1Error">设置6位数字的交易密码</div>
            </div>
            <div class="input-grp">
                <input type="password" maxlength="6" v-model="passwd2" @input="passwd2Error = false" placeholder="再次输入新交易密码">
                <div class="notice" v-show="passwd2Error">两次密码输入不一致</div>
            </div>
            <div class="btn-confirm" @click="nextStep">下一步</div>
            <!-- <div class="btn-confirm disabled">下一步</div> -->
        </div>
        <div class="page-content step-2" v-show="currentStep == 2">
            <div class="page-top">
                <div>为了保障您的交易安全</div>
                <div>将向您的 <span>{{displayMobile}}</span> 手机号码发送验证码</div>
            </div>
            <div class="input-grp">
                <div class="pic-code-box">
                    <input type="text" v-model="verficationPic" placeholder="请输入右侧验证码内容">
                    <img :src="imgSrc" alt="" class="code-pic">
                </div>
                <div class="notice" v-show="piccodeError">图形验证码不正确</div>
            </div>
            <div class="msg-code-box">
                <input type="text" v-model="qrCode" placeholder="请输入短信验证码">
                <span class="btn-getcode">
                    <span @click="sendMsg" v-show="!showCountdown">获取验证码</span>
                    <span v-show="showCountdown">(<van-count-down ref="countDown" :time="time" :auto-start="false" format="ss" @finish="countdownFinish" />s)重新获取</span>
                </span>
            </div>
            <div class="btn-confirm" @click="confirm">确认修改</div>
            <!-- <div class="btn-confirm disabled">确认修改</div> -->
        </div>
        <div class="page-bottom">
            <a href="tel:4001017057">客服电话：4001017057</a>
        </div>
    </div>
</template>
<script>
import { Field,CountDown,Toast } from 'vant'
import {phoneYm} from '@/lib/util'
import $http from '@/lib/request'
import config from '@/config'
import md5 from 'js-md5'

export default {
    data(){
        return {
            passwd1:'',
            passwd2:'',
            passwd1Error:false,
            passwd2Error:false,
            piccodeError:false,
            passwdOrigin:'',
            currentStep:1,//当前在第几步
            time: 60 * 1000,//短信验证码倒计时
            showCountdown:false,//是否展示倒计时
            imgSrc:'',//图片验证码
            originImgsrc:'',//接口返回的原始图片验证码流
            mobile:'',//用户手机号
            displayMobile:'',//用来展示的中间加***的手机号
            qrCode:'',//短信验证码
            verficationPic:'',//用户输入的图片验证码
        }
    },
    components:{
        [Field.name]:Field,
        [CountDown.name]:CountDown,
        [Toast.name]:Toast
    },
    activated(){
        let mobile=JSON.parse(window.localStorage.getItem('userInfo')).mobile;
        this.displayMobile=phoneYm(mobile)
        this.mobile=mobile;
        

        this.getPicCode();
    },
    deactivated(){
        this.passwd1='';
        this.passwd2='';
        this.passwd1Error=false;
        this.passwd2Error=false;
        this.piccodeError=false;
        this.passwdOrigin='';
        this.currentStep=1;//当前在第几步
        this.time= 60 * 1000;//短信验证码倒计时
        this.showCountdown=false;//是否展示倒计时
        this.imgSrc='';//图片验证码
        this.originImgsrc='';//接口返回的原始图片验证码流
        this.mobile='';//用户手机号
        this.displayMobile='';//用来展示的中间加***的手机号
        this.qrCode='';//短信验证码
    },
    methods:{
        //获取图片验证码
        getPicCode(){
            $http({
                method:'post',
                url:config.api.graphCode
            }).then((res)=>{
                if(res.errno == 0){
                    this.imgSrc='data:image/png;base64,'+res.data.imgsrc;
                    this.originImgsrc=res.data.imgsrc;
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        nextStep(){
            let reg=/^\d{6}$/;
            if(!reg.test(this.passwd1) || !reg.test(this.passwd2)){
                Toast('请设置6位数字的密码');
                return;
            }
            $http({
                method:'post',
                data:{
                    oldPwd:md5(this.passwdOrigin),
                    newPwd:md5(this.passwd1),
                    repeatPwd:md5(this.passwd2)
                },
                url:config.api.validationPwd
            }).then((res)=>{
                if(res.errno == 0){
                    this.currentStep=2;
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        confirm(){
            if(this.passwd1 !== this.passwd2){
                this.passwd2Error=true;
                return;
            }
            let reg=/^\d{6}$/;
            if(!reg.test(this.passwd1) || !reg.test(this.passwd2)){
                Toast('请设置6位数字的密码');
                return;
            }
            $http({
                method:'post',
                data:{
                    mobile:this.mobile,
                    oldPwd:md5(this.passwdOrigin),
                    newPwd:md5(this.passwd1),
                    repeatPwd:md5(this.passwd2),
                    qrCode:this.qrCode
                },
                url:config.api.updateJypass
            }).then((res)=>{
                if(res.errno == 0){
                    Toast('密码修改成功！');
                    setTimeout(()=>{
                        this.$router.replace({
                            name:'mine'
                        });
                    },1000);
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        sendMsg(){
            $http({
                method:'post',
                data:{
                    mobile:this.mobile,
                    verifyCode:this.verficationPic,
                    vCodeKey:'vcode'+md5(this.originImgsrc),
                    type:3
                },
                url:config.api.getSmsCode
            }).then(res=>{
                if(res.errno == 0){
                    Toast('验证码发送成功，5分钟内有效！');
                    // 开始倒计时
                    this.showCountdown=true;
                    this.$refs.countDown.start();
                }else{
                    Toast(res.errmsg);
                    this.verficationPic='';
                    this.getPicCode();
                }
            });
        },
        countdownFinish(){
            this.showCountdown=false;
            this.$refs.countDown.reset();
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
::v-deep .van-cell::after{
    border-bottom: none;
}
::v-deep .van-count-down{
    display: inline;
    color:#3088F5;
}
.page-container{
    padding:15px;
    background: #f5f5f5;
    min-height: 100vh;
    box-sizing: border-box;
    .page-top{
        padding:10px;
        margin-bottom: 40px;
        &>div{
            color:#333;
            line-height: 28px;
            font-size: 15px;
            text-align: center;
            &>span{
                margin-left: 5px;
                font-size: 18px;
            }
            margin-bottom: 5px;
        }
    }
    .page-title{
        color:3333;
        font-size: 16px;
        line-height: 22px;
        &>span{
            font-size: 12px;
            color:#999;
            margin-left: 5px;
        }
        margin-bottom: 10px;
    }
    .page-content{
        .input-grp{
            margin-bottom: 15px;
            &>input{
                display: block;
                width:100%;
                height:44px;
                background:#fff;
                border:none;
                box-sizing: border-box;
                padding:0 20px;
                border-radius: 4px;
                font-size: 14px;
            }
            .notice{
                margin-top: 8px;
                font-size: 12px;
                color:#e43d3d;
            }
        }
        .btn-confirm{
            height: 44px;
            line-height: 44px;
            border-radius: 4px;
            text-align: center;
            font-size: 16px;
            margin-top: 70px;
            color:#fff;
            background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
            &.disabled{
                color:#999;
                background: #DCDCDC;
            }
        }
    }
    .step-2{
        .pic-code-box{
            @include flex-between();
            margin-bottom: 15px;
            &>input{
                width:250px;
                height:44px;
                box-sizing: border-box;
                padding:0 20px;
                font-size: 14px;
                background:#fff;
                border-radius: 4px;
                border:none;
            }
            .code-pic{
                width:78px;
                height:44px;
                border-radius: 4px;
            }
        }
        .msg-code-box{
            background:#fff;
            border-radius: 4px;
            @include flex-between();
            padding-right: 15px;
            &>input{
                width:200px;
                height:44px;
                box-sizing: border-box;
                padding:0 20px;
                font-size: 14px;
                background:#fff;
                border-radius: 4px;
                border:none;
            }
            .btn-getcode{
                font-size: 16px;
                color:#3088F5;
                line-height: 22px;
            }
        }
    }
    .page-bottom{
        position: fixed;
        width:100vw;
        text-align: center;
        bottom:15px;
        left:0;
        font-size: 14px;
        line-height: 20px;
        &>a{
            color:#3088F5;
        }
    }
}
</style>